/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export let StorageCategory = /*#__PURE__*/function (StorageCategory) {
  StorageCategory["PRIMARY"] = "PRIMARY";
  StorageCategory["SECONDARY"] = "SECONDARY";
  StorageCategory["NONE"] = "NONE";
  return StorageCategory;
}({});
//# sourceMappingURL=StorageCategory.js.map
